uniform float uTime;
uniform float uStarDensity;
uniform float uTwinkleSpeed;
uniform float uBrightness;
uniform float uPattern;
uniform vec3 uTint;             // セクションごとの色味（暖色/寒色）
uniform float uTwinkleAmount;   // 瞬きの深さ (0 = 瞬きなし)
uniform float uNebulaIntensity; // 星雲の濃さ (0 = なし)

varying vec3 vPosition;
varying vec3 vNormal;
varying vec2 vUv;


// ランダム関数 vec2
float random(vec2 st)
{
  return fract(sin(dot(st.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

// ランダム関数 vec3
float random(vec3 st)
{
  return fract(sin(dot(st.xyz, vec3(12.9898, 78.233, 45.164))) * 43758.5453);
}

// TODO: Perlin Texture を用いてランダム関数実装できないかな？
// ノイズ関数
float noise(vec2 st) {
    vec2 i = floor(st);
    vec2 f = fract(st);
    float a = random(i);
    float b = random(i + vec2(1.0, 0.0));
    float c = random(i + vec2(0.0, 1.0));
    float d = random(i + vec2(1.0, 1.0));
    vec2 u = f * f * (3.0 - 2.0 * f);
    return mix(a, b, u.x) + (c - a)* u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

// Please provide the code selection you want documented.
//Point: Fragment Shaderは各頂点座標の間を補うように各ピクセルで実行される!
void main() {
  // step1: 球面座標系に変換
  // 各ピクセルの位置を球面上の単位ベクトルに変換 → 各ピクセルが球面上の単位ベクトルに変換
  vec3 pos = normalize(vPosition);                              // 補完された連続的な位置
  // step2: 球面座標への変換
  // 3D座標 → 2D球面座標（経度・緯度のような概念。 言い換えると、3D空間の位置を2D座標にマッピング。地球儀を平面地図にする感じ。
  /* 3D座標を球面座標に変換する方法
    球面座標系では、位置は経度と緯度で表されます。
    3D座標 (x, y, z) を球面座標 (θ, φ) に変換するには以下の式を使用します。
    θ = atan2(z, x) // 経度
    φ = acos(y / length(vec3(x, y, z))) // 緯度
  */
  vec2 sphericalCoord = vec2(atan(pos.z, pos.x), acos(pos.y));  // 連続的な球面座標

  // step3: グリッド分割 (uStarDensityの数だけ分割 80x80のグリッドなど)
  // 球面座標を分割数で拡大して、グリッド座標に変換
    // sphericalCoord: (0.0 ~ 6.28, 0.0 ~ 3.14) の球面座標
    // uStarDensity: 80 (分割数)
    // starCoord: (0.0 ~ 502.4, 0.0 ~ 251.2) に拡大
  vec2 starCoord = sphericalCoord * uStarDensity;
  // グリッド座標を整数に変換して、グリッド内の位置を計算.
  // floor()関数で小数部分を切り捨て、どのグリッドに属するかを特定します。 これがグリッドの「住所」になります。
    // starGrid: (0.0 ~ 502, 0.0 ~ 251) のグリッド座標
  vec2 starGrid = floor(starCoord);
  // グリッド内の位置を計算
    // fract()関数で小数部分を取り出し、グリッド内の位置を計算します。 これがグリッド内の「座標」になります。
  vec2 starLocal = fract(starCoord);

  float star = 0.0;
  float starBrightness = 0.0;

  // 通常の星空パターン
    // ランダムな値を生成して、星の存在確率を決定
    // NOTE: このif文を無くすと、全てのグリッドに星が存在するようになるので面白いよ！
  float starChance = random(starGrid);                        // グリッドごとのランダム値
  if (starChance > 0.95)
  {
    float dist = distance(starLocal, vec2(0.5));                // グリッド内の位置から中心までの距離
    star = 1.0 - smoothstep(0.0, 0.3, dist);                    // 中心からの距離が0.2以下なら星が存在. 0.2の値が小さいほど、星が密集する
    starBrightness = random(starGrid + vec2(1.0)) * 0.5 + 0.5;  // グリッドごとのランダム値を使って星の明るさを決定
  }

  // 星雲の背景色: FBM（数オクターブのノイズ重ね合わせ）で深藍と残り火色の淡いガス雲を描く
  vec2 nebulaCoord = sphericalCoord * 2.5 + vec2(uTime * 0.004, 0.0);
  float nebulaNoise = noise(nebulaCoord) * 0.5
                    + noise(nebulaCoord * 2.0) * 0.25
                    + noise(nebulaCoord * 4.0) * 0.125;
  float nebulaBlend = noise(nebulaCoord * 1.7 + vec2(37.2, 11.8));
  vec3 nebulaColor = mix(vec3(0.04, 0.10, 0.25), vec3(0.25, 0.10, 0.04), nebulaBlend);
  float nebula = smoothstep(0.35, 0.85, nebulaNoise) * uNebulaIntensity;

  // 点滅効果: 星ごとに速度と位相をずらして、一斉に明滅しないようにする
  float twinkleWave = sin(uTime * uTwinkleSpeed * (0.5 + random(starGrid)) + random(pos) * 6.28) * 0.5 + 0.5;
  float twinkle = mix(1.0, twinkleWave, uTwinkleAmount);
  star *= twinkle;

  // 色の計算
  vec3 starColor = vec3(1.0);

  // 星の色のバリエーション
  float colorSeed = random(pos + vec3(100.0));
  if (colorSeed > 0.8) {
      starColor = vec3(1.0, 0.8, 0.6); // オレンジ系
  } else if (colorSeed > 0.6) {
      starColor = vec3(0.8, 0.9, 1.0); // 青白系
  } else if (colorSeed > 0.4) {
      starColor = vec3(1.0, 1.0, 0.9); // 黄色系
  }

  // 最終的な出力（加算ブレンドなので星雲は alpha にも寄与させる）
  vec3 finalColor = (starColor * star * starBrightness * uBrightness + nebulaColor * nebula) * uTint;

  gl_FragColor = vec4(finalColor, star * starBrightness + nebula * 0.6);
}